import React, { ReactNode } from "react";
import CloseIcon from "@mui/icons-material/Close";

import "./styles/index.css"; // Import CSS file for styling
import { Container } from "@mui/material";

interface FlyoverProps {
  isOpen: boolean;
  closeMenu: () => void;
  children: ReactNode;
}

const Flyover: React.FC<FlyoverProps> = ({ isOpen, closeMenu, children }) => {
  return (
    <div className={`flyover ${isOpen ? "open" : ""}`}>
      <Container className="overlay">
        <CloseIcon fontSize="large" onClick={closeMenu} />
      </Container>
      <Container className="flyover-content">{children}</Container>
    </div>
  );
};

export default Flyover;
